import { connect } from 'react-redux'
import { getFromSettings } from 'src/utils/helpers'
import {
  resetUser,
  setUser,
  setEmail,
  clearEmail,
  setUserLastAccessType,
} from 'src/modules/Users/actions'
import { setSettings, resetApp, setLanguage, setFeatures } from 'src/modules/App/actions'
import { setAppActionsDisabledState } from 'src/modules/App/nonPersistentActions'
import { updateChatSessionState } from 'src/modules/Chat/actions'

import Email from './Email'

const mapDispatchToProps = {
  setUser,
  setSettings,
  resetUser,
  resetApp,
  setEmail,
  clearEmail,
  setLanguage,
  setUserLastAccessType,
  setAppActionsDisabledState,
  updateChatSessionState,
  setFeatures,
}

const mapStateToProps = state => {
  return {
    user: state.user.user,
    email: state.user.email,
    setEmailTimestamp: state.user.setEmailTimestamp,
    isChatEmpty: state.chat.isChatEmpty,
    isWidgetState: state.appReducer.isWidget,
    terms: getFromSettings(state, 'terms', {}),
    areAppActionsDisabled: state.nonPersistentAppReducer.areAppActionsDisabled,
    currentlyOpenFeature: state.appReducer.currentlyOpenFeature,
    features: state.appReducer.features,
    pageBackground: state.appReducer.settings.brand.colors.backgroundColor,
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Email)
